import { render, staticRenderFns } from "./CMicrophoneRecorder.vue?vue&type=template&id=2708b424&scoped=true&"
import script from "./CMicrophoneRecorder.vue?vue&type=script&lang=ts&"
export * from "./CMicrophoneRecorder.vue?vue&type=script&lang=ts&"
import style0 from "./CMicrophoneRecorder.vue?vue&type=style&index=0&id=2708b424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708b424",
  null
  
)

export default component.exports